import { render, staticRenderFns } from "./Seo.vue?vue&type=template&id=58cc7ae9"
import script from "./Seo.vue?vue&type=script&lang=js"
export * from "./Seo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58cc7ae9')) {
      api.createRecord('58cc7ae9', component.options)
    } else {
      api.reload('58cc7ae9', component.options)
    }
    module.hot.accept("./Seo.vue?vue&type=template&id=58cc7ae9", function () {
      api.rerender('58cc7ae9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Seo.vue"
export default component.exports